import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Dropdown } from 'rsuite'
// import pathname from '../../constants/pathname'
// import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
// import EditButton from '../../components/buttons/editButton/EditButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'

export default function ProjectMonitorRecordTable({
  schema,
  data,
  loading,
  onDelete,
  onSelect,
  isViewMode,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  // const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  console.log('data==>', data)

  // const fs = localStorage.getItem('fontSize')
  // const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }

  useEffect(() => {
    setTableData(data?.values || [])
  }, [schema])

  return (
    <>
      <Table
        wordWrap
        rowHeight={60}
        minHeight={350}
        autoHeight
        loading={loading}
        data={tableData || []}
      >
        {/* <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column> */}

        <Column width={130} align={'left'}>
          <HeaderCell>วันที่ลงติดตาม</HeaderCell>
          <Cell dataKey="dateFollow" />
        </Column>

        <Column width={110} align={'left'}>
          <HeaderCell>ติดตามครั้งที่ </HeaderCell>
          <Cell dataKey="followTimes" />
        </Column>

        <Column width={210} align={'left'}>
          <HeaderCell>% ความสำเร็จของโครงการ</HeaderCell>
          <Cell dataKey="projectSuccessInput" />
        </Column>

        <Column align={'left'} width={250}>
          <HeaderCell>สรุปความเห็นผู้ติดตาม</HeaderCell>
          <Cell dataKey="summarizeInput" />
        </Column>

        <Column minWidth={250} align={'left'} flexGrow={1}>
          <HeaderCell>ข้อสังเกต</HeaderCell>
          <Cell dataKey="notesInput" />
        </Column>
        <Column width={150} align="center" fixed="right">
          <HeaderCell>คลิก</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ButtonGroup>
                    <ViewButton
                      icon="download"
                      onClick={() => {
                        onSelect(rowData)
                      }}
                    >
                      ดาวน์โหลด
                    </ViewButton>
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
        <Column width={120} align="center" fixed="right">
          <HeaderCell>คลิก</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ButtonGroup>
                    <SaveButton
                      icon="eye"
                      onClick={() => {
                        onSelect(rowData)
                      }}
                    >
                      แสดง
                    </SaveButton>
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <ConfirmWidget
        title={`ยืนยันการลบรายการ`}
        show={isShowConfirm}
        detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsShowConfirm(false)
          setDeleteObj({})
        }}
        onConfirm={() => {
          onDelete(deleteObj)
          setIsShowConfirm(false)
        }}
      />
    </>
  )
}
